<template>

  <div class="p-2">
    <!--    <div class="mb-2 d-flex justify-content-end">-->
    <!--      <button-->
    <!--        class="btn btn-primary"-->
    <!--        @click="salvarAluno()"-->
    <!--      >-->
    <!--        + Aluno-->
    <!--      </button>-->
    <!--    </div>-->
    <b-table
      striped
      hover
      responsive
      :per-page="perPage"
      :current-page="currentPage"
      :items="alunos"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :filter="filter"
      :filter-included-fields="filterOn"
      @filtered="onFiltered"
    >
      <template #cell(Phone)="data">
        <span class="text-nowrap">
          {{ data.value }}
        </span>
      </template>
      <!-- Optional default data cell scoped slot -->
      <template #cell()="data">
        {{ data.value }}
      </template>
    </b-table>
  </div>

</template>

<script>
import { BAvatar, BBadge, BTable } from 'bootstrap-vue'
import { useApi } from '@/composables/useApi'

const apiBack = useApi()
export default {
  components: {
    BAvatar,
    BBadge,
    BTable,
  },
  data() {
    return {
      fields: [
        'aluno_nome',
        'aluno_email',
        {
          key: 'aluno_telefone', label: 'Phone',
        },
      ],
      alunos: [],
      perPage: 5,
      pageOptions: [3, 5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      cursoId: this.$route.params.id,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      items: [
        {
          id: '1',
          aluno_nome: 'Marybelle',
          aluno_email: 'Della Scala',
          aluno_telefone: 'mdellascala0@opensource.org',
        },
      ],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    getUserData: {
      get() {
        const newUserData = JSON.parse(localStorage.getItem('userData'))
        if (newUserData !== null) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.domainUser = newUserData.user_domain
          return newUserData
        }
        return {}
      },
      set(value) {
        localStorage.setItem('userData', JSON.stringify(value))
      },
    },
  },
  async mounted() {
    await this.listarAlunos()
    // Set the initial number of items
    this.totalRows = this.items.length
  },
  methods: {
    async listarAlunos() {
      await apiBack.get(`/findAlunoByCurso?id=${this.cursoId}`)
        .then(data => {
          this.alunos = data.data
        })
        .catch(err => console.error(err))
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>
